import React from "react";
import { Box, BoxStatus, SimpleHorizontalChart } from "codekit";

/**
 * Barras horizontales de DOs por gerencia del monitor de entrega urgente
 * @author Oscar Rosero <oscar.rosero@repremundo.com.co>
 * @since 2026-05-01
 * @param data
 */
const Gerbarsx = ({ data }) => {
  return (
    <Box border={1} rounded="lg" spacing={4} shadow>
      {data.length === 0 ? (
        <BoxStatus variant="empty" text="Sin datos por gerencia" />
      ) : (
        <SimpleHorizontalChart
          subtitle="Antigüedad por gerencia"
          title="DOs críticos y en alerta"
          barColor="error-500"
          data={data
            .filter((g) => g.critico > 0)
            .map((g) => ({
              name: g.name,
              value: g.critico,
              sideLabel: `${g.ambar} alerta`,
            }))}
          maxItems={5}
        />
      )}
    </Box>
  );
};

export default Gerbarsx;
